import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SnapshotSharedVariablesService {

  snapshotCount: number = 0;
  clientDetails: any = {
    client_name: "",
    study: "",
    configdata:[]
  };
 selectedSnapshotName: string = '';

  topicsSelection: { snapshotType: string; sectionName: string; subSectionName: string } = {
    snapshotType: '',
    sectionName: '',
    subSectionName: ''
  };
  studyNameDetails: any = [];
  entryPointsDetails: any = [];
  dimensionsDetails: any = [];

  constructor() { }
}
